(function (module) {
    'use strict';

    /**
     * Disable angular-formly's api-check at runtime.
     *
     * Fixes the stage 2026-08-09 crash on the Achievers edit screen:
     *
     *   SecurityError: Failed to read a named property 'constructor' from
     *   'Window': Blocked a frame with origin
     *   "https://manager.stage.signagerocket.com" from accessing a
     *   cross-origin frame.
     *
     * Root cause (decoded from the stage stack trace — the repeating 5-frame
     * group in libs-*.min.js:15 is api-check's recursive type describer):
     *
     *  1. angular-formly's FormlyFieldController calls checkApi(options) on
     *     EVERY formly-field instantiation (formly-field.js:48 →
     *     formlyApiCheck.throw(formlyFieldOptions, options)).
     *  2. api-check's apiCheck() calls getTypes(api, args) UNCONDITIONALLY —
     *     even when the check PASSES (api-check/src/api-check.js:87). getTypes
     *     → getArgDisplay deep-walks the entire own-enumerable object graph of
     *     the checked options and reads `.constructor` on every node
     *     (api-check.js:244, :336).
     *  3. A field hidden via `hideExpression` renders under ng-if. When it is
     *     re-shown, its persistent options object still carries `formControl`
     *     (an NgModelController) from the previous mount — formly stores it on
     *     options and never removes it (formly-field.js:406-416).
     *     NgModelController owns `$$scope`/`$$rootScope` (angular.js
     *     :30293-30295), so the walk escapes into the live scope/controller
     *     graph and eventually reaches a cross-origin WindowProxy (the player
     *     preview iframe on player.<env>.signagerocket.com). Reading
     *     `constructor` on it throws, mid-digest, aborting the digest — the
     *     re-shown field never renders and the app preview hangs on loading.
     *  4. First render is safe because options has no formControl yet, which
     *     is why the bug needs "switch feed away, then back" (achievers
     *     schema 1.0.14's longServiceLayout / commentOverflowBehavior).
     *
     * The fix: disable the formlyApiCheck instance, which short-circuits
     * apiCheck() BEFORE the arg walk (api-check.js:66). This is api-check's
     * own documented production mode. formly routes every runtime check
     * through this instance (checkApi field/type checks and wrapper checks),
     * so no runtime deep walk remains. Config-time checks of our own
     * setType()/setWrapper() calls still run: module .config() blocks execute
     * before .run() blocks.
     *
     * Note this only removes the crash. The independent angular-formly 8.4.1
     * ng-if re-render desync (a field hidden at FIRST render is never
     * re-inserted — stage 2026-07-22) still applies to `hideExpression`
     * fields; use the cssHideInput/cssHideSelect types for fields that must
     * toggle visibility. See formly-css-hide-input.js / formly-css-hide-select.js.
     */
    module.run(['formlyApiCheck', (formlyApiCheck) => {
        formlyApiCheck.config.disabled = true;
    }]);
})(angular.module('rocket.components'));
